export default __webpack_public_path__ + "static/frase2-3da7d57bbef31729755082d907f9194b.png";